import { IonAccordion, IonAccordionGroup, IonButton, IonButtons, IonCard, IonCardHeader, IonCardSubtitle, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonNavLink, IonNote, IonPage, IonRow, IonSpinner, IonTitle, IonToolbar, useIonAlert } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTopupSendCreateMutation, useTopupSendMutation } from "../../services/api/ebioro/ebioro";
import { useAccountDetailsQuery } from "../../services/api/stellar";
import { useAppSelector } from "../../services/redux/hook";
import { TopUpPriceObject, Asset, TopUpCreateRequestParameters, TopUpSendRequestParameters, WalletInfoState, TopUpProvider, TopUpContact } from "../../types/types";
import './Topup.css';
import * as Sentry from '@sentry/react';
import * as stellarSdk from '@stellar/stellar-sdk';
import * as stellarTxBuilder from '../../services/stellar/TransactionBuilder';
import * as sep7 from '../../services/stellar/sep7';
import { arrowBackOutline } from "ionicons/icons";
import PaymentProcessing from "../payment-processing/PaymentProcessing";

const TopupReviewPage: React.FC = () => {

    const { t, i18n } = useTranslation();

    const nav = document.querySelector("ion-nav");

    const [description, setDescription] = useState<any[]>([]);
    const language = useAppSelector((state) => state.language);
    const [isSpinner, setIsSpinner] = useState(false);
    const supportedAssets: Asset[] = useAppSelector((state) => state.supportedAssets.supportedAssets);
    const [createTopUp, result] = useTopupSendCreateMutation();
    const [sendTopup, sendTopResult] = useTopupSendMutation();
    const [disabled, setDisabled] = useState(false);
    const topUpContact: TopUpContact = useAppSelector((state) => state.topUpContact);
    const seletedTopProvider: TopUpProvider = useAppSelector((state) => state.selectedTopUpProvider);
    const topUpPricing: TopUpPriceObject = useAppSelector((state) => state.topUpPricing);

    const [present] = useIonAlert();

    const presentErrorAlert = (message: any) => {

        setIsSpinner(false);
        present({
            header: 'Error',
            message: `${message}`,
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    handler: () => {
                        return
                    }
                }
            ],

        })

    }

    const supportedTopUpAsset = supportedAssets.filter((asset) => {

        return (asset.topups_enabled)
    })

    const [topupAsset, setTopUpAsset] = useState<Asset>(supportedTopUpAsset[0]);

    const walletInfo: WalletInfoState = useAppSelector((state) => state.walletInfo);
    const { data: accountDetails } = useAccountDetailsQuery(walletInfo.account_key);

    const assetBalance = accountDetails?.details.balances[topupAsset.identifier] ? accountDetails?.details.balances[topupAsset.identifier].available.toNumber() : 0;

    const [totalToPay, setTotalToPay] = useState<number>(0);

    useEffect(() => {

        const init = async () => {

            let description = []

            description = topUpPricing.Product.descriptions.filter((element: any) => {

                return (element.language_code === language)
            })


            if (!description.length) {

                description = topUpPricing.Product.descriptions.filter((element: any) => {

                    return (element.language_code === 'en')
                })
            }

            setDescription(description);

            const toPay = (topUpPricing?.UsdcDisplayPrice as number) + (topUpPricing?.UsdcDisplayCustomerFee as number)

            setTotalToPay(toPay);
        }

        init();

    }, [topUpPricing, seletedTopProvider])


    const sendTopUpTransfer = async () => {

        setIsSpinner(true);
        setDisabled(true);

        const params: TopUpCreateRequestParameters = {


            sku_code: topUpPricing?.Product?.sku_code as string,
            send_value: topUpPricing?.Price.SendValue as number,
            send_currency_iso: topUpPricing?.Price.SendCurrencyIso as string,

            amount_in: (topUpPricing?.UsdcDisplayPrice as number) + (topUpPricing?.UsdcDisplayCustomerFee as number),
            fee_value: topUpPricing?.UsdcDisplayCustomerFee as number,
            asset_code: topupAsset.code,
            asset_issuer: topupAsset.identifier.split(":")[1] ? topupAsset.identifier.split(":")[1] : undefined,
            account_number: topUpContact.phone_number.split('+')[1] as string, // topup provider does not accept "+" in the phone number
            reciever_full_name: topUpContact.contact_name
        }

        try {

            const response = await createTopUp(params).unwrap();

            const destination_address = response.withdraw_anchor_account;
            const destination_amount = totalToPay.toFixed(2);
            const destination_asset = topupAsset.code;
            let destination_asset_issuer = undefined;

            if (topupAsset.identifier != 'native') {
                destination_asset_issuer = topupAsset.identifier.split(":")[1]
            }

            let stellarTx: stellarSdk.Transaction<stellarSdk.Memo<stellarSdk.MemoType>, stellarSdk.Operation[]>;

            const [error, transaction] = await stellarTxBuilder.createPayment(
                destination_address,
                walletInfo.account_key as string,
                walletInfo.device_private_key as string, destination_amount, destination_asset, destination_asset_issuer);

            stellarTx = transaction as stellarSdk.Transaction<stellarSdk.Memo<stellarSdk.MemoType>, stellarSdk.Operation[]>;

            const uri = createSep7URI(stellarTx);

            const sendTopUpData: TopUpSendRequestParameters = {
                uri: uri?.toString() as string,
                asset_code: destination_asset,
                account: walletInfo.account_key as string,
                id: response.id
            }

            const sendTopResponse = await sendTopup(sendTopUpData).unwrap();

            const stellarTxId = sendTopResponse.stellar_transaction_id as string;
            setIsSpinner(false);
            nav?.push(() => <PaymentProcessing transactionId={stellarTxId} />)


        } catch (error: any) {

            Sentry.captureException(error);

            if (error.message === 'submission_error') {
                presentErrorAlert(t('transaction.submission.ERROR'))

            }

            else {

                presentErrorAlert(t('application.uncaught.ERROR'));
            }

            return;

        }
    }

    const createSep7URI = (stellarTx: stellarSdk.Transaction<stellarSdk.Memo<stellarSdk.MemoType>, stellarSdk.Operation[]>) => {

        if (walletInfo) {

            return sep7.createSep7URI(stellarTx, walletInfo.account_key as string/*, message*/);

        }

        return null

    }


    return (
        <IonPage>

            <IonHeader className="ion-no-border">

                <IonToolbar style={{ marginTop: "0%" }}>
                    <IonNavLink routerDirection={'back'}>
                        <IonButtons slot='start'>
                            <IonButton color={'primary'}>
                                <IonIcon slot='start' icon={arrowBackOutline} />
                            </IonButton>
                        </IonButtons>
                    </IonNavLink>
                    <IonTitle> {t('topups_review.page.HEADER') as string}</IonTitle>
                </IonToolbar>

        

            </IonHeader>

            <IonContent>

                <IonGrid className="ion-padding">

                    <IonRow>
                        <IonCol>
                            <IonItem lines="none" className="topup_item">

                                <h5 slot="start" className="ion-text-wrap">
                                    {t('topups_review.page.SENDING-LABEL')}
                                </h5>

                                {
                                    (topUpPricing?.Product.maximum.SendValue === topUpPricing?.Product.minimum.SendValue) ?
                                        <h5 className="ion-text-wrap" slot="end">

                                            <b>{description.length ? description[0].display_text : ""}</b>
                                        </h5> :
                                        <h5 slot="end" className="ion-text-wrap">
                                            {`${topUpPricing?.Price.ReceiveValueExcludingTax} ${topUpPricing?.Price.ReceiveCurrencyIso} `}
                                        </h5>
                                }

                            </IonItem>

                        </IonCol>

                    </IonRow>

                    <IonRow>
                        <IonCol style={{ margin: "auto" }}>
                            <IonItem lines="none" className="topup_item">
                                <h5 slot="start" className="ion-text-wrap">
                                    {t('topups_review.page.PROVIDER-LABEL')}
                                </h5>

                            </IonItem>

                        </IonCol>
                        <IonCol style={{ margin: "auto" }} >
                            <IonCard>
                                <IonItem lines="none">
                                    <IonImg slot="start" src={seletedTopProvider?.logo_url} className="providerImage" />
                                </IonItem>
                                <IonCardHeader>
                                    <IonCardSubtitle
                                        
                                    >{seletedTopProvider?.name}</IonCardSubtitle>
                                </IonCardHeader>


                            </IonCard>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol style={{ margin: "auto" }} size="12">
                            <IonItem lines="none" className="topup_item ion-text-start">
                                <div slot="start" className="ion-text-wrap">
                                    <h5 > {t('topups_review.page.RECIPIENT-LABEL')}</h5>

                                </div>
                                <div slot="end" className="ion-text-wrap">
                                    <h5>
                                        {topUpContact.contact_name}
                                    </h5>
                                    <IonNote className="ion-text-wrap topup_recipient_note">{topUpContact.phone_number}</IonNote>

                                </div>

                            </IonItem>


                        </IonCol>

                    </IonRow>

     

                    <IonRow>
                        <IonCol>
                            <IonAccordionGroup className="topup_review_accordion_group" expand="inset" value={"first"}>

                                <IonAccordion value="first">
                                    <IonItem slot="header" lines='none' color='primary'>
                                        <IonLabel >
                                            <b>
                                                {t('topups_review.page.PAY-LABEL')} {(totalToPay).toFixed(2)} {`${topupAsset.code}`}
                                            </b>
                                        </IonLabel>
                                    </IonItem>
                                    
                                    <div  slot="content" style={{padding: "0px" }}>
                                        <hr style={{ margin: "0px" }} />
                                        <IonItem lines="none">

                                            <IonLabel slot="start" className="ion-text-wrap">
                                                {t('topups_review.page.SUBTOTAL-LABEL')}
                                            </IonLabel>

                                            <IonLabel slot="end" className="ion-text-wrap">
                                                {(topUpPricing?.UsdcDisplayPrice.toFixed(2))} {`${topupAsset.code}`}
                                            </IonLabel>

                                        </IonItem>
                                        <IonItem lines="none">

                                            <IonLabel slot="start" className="ion-text-wrap">
                                                {t('topups_review.page.FEE-LABEL')}
                                            </IonLabel>

                                            <IonLabel slot="end" className="ion-text-wrap">
                                                {(topUpPricing?.UsdcDisplayCustomerFee.toFixed(2))} {`${topupAsset.code}`}
                                            </IonLabel>

                                        </IonItem>

                                        <IonItem lines="none">
                                            <IonLabel slot="start" className="ion-text-wrap">
                                                {t('topups_review.page.TOTAL-LABEL')}
                                            </IonLabel>
                                            <IonLabel slot="end" className="ion-text-wrap">
                                                {totalToPay.toFixed(2)} {`${topupAsset.code}`}
                                            </IonLabel>

                                        </IonItem>
                                    </div>
                                </IonAccordion>

                            </IonAccordionGroup>


                        </IonCol>
                    </IonRow>

                </IonGrid>

                <IonToolbar>
                    <IonButton
                        color={'primary'}
                        type="submit"
                        onClick={() => { sendTopUpTransfer() }}
                        expand="block"
                        id="pageFooterButton"
                        disabled={(assetBalance < parseFloat((totalToPay).toFixed(2))) || disabled}>
                        {
                            isSpinner ? (<IonSpinner className="BUTTON-SPINNER"></IonSpinner>)
                                :
                                assetBalance < parseFloat((totalToPay).toFixed(2)) ?
                                    t('send.page.NOT-ENOUGH-FUNDS') : t('topups_review.page.SEND.BTN-LABEL') + ` ${totalToPay.toFixed(2)} ${topupAsset.code}`
                        }
                    </IonButton>
                </IonToolbar>
           
            </IonContent>

        </IonPage>
    )
}

export default React.memo(TopupReviewPage);